let cartLockCount = 0;
let cartLockFailSafe = null;

function lockCart() {
  cartLockCount++;
  updateCheckoutState();
  clearTimeout(cartLockFailSafe);
  cartLockFailSafe = setTimeout(() => {
    cartLockCount = 0;
    updateCheckoutState();
    console.warn('Cart lock reset by failsafe');
  }, 10000);
}

function unlockCart() {
  cartLockCount = Math.max(0, cartLockCount - 1);
  updateCheckoutState();
  if (cartLockCount === 0) clearTimeout(cartLockFailSafe);
}

function updateCheckoutState() {
  const isLocked = cartLockCount > 0;
  const buttons = [
    document.querySelector('#cart-drawer button[name="checkout"]'),
    document.querySelector('.main-cart-items-wrapper button[name="checkout"]')
  ];
  buttons.forEach(btn => {
    if (!btn) return;
    btn.disabled = isLocked;
    btn.style.pointerEvents = isLocked ? 'none' : '';
    btn.style.opacity = isLocked ? '0.5' : '';
    btn.style.cursor=isLocked?'not-allowed':'';
  });
}

document.addEventListener('click', e => {
  const btn = e.target.closest('button[name="checkout"]');
  if (!btn) return;
  if (cartLockCount > 0) {
    e.preventDefault();
    e.stopPropagation();
  }
}, true);


class WelcomeKitCart extends HTMLElement {
  constructor() {
    super();
    this.isUpdatingWelcomeKit = false;
    this.eligibleVariantIds = this.dataset.welcomeKitEligibleVariants ? this.dataset.welcomeKitEligibleVariants.split(',').map(id => parseInt(id)).filter(id => !isNaN(id)) : [];
    this.welcomeKitVariantIds = this.dataset.welcomeKitVariants ? this.dataset.welcomeKitVariants.split(',').map(id => parseInt(id)).filter(id => !isNaN(id)): [];
  }

  connectedCallback() {
    if (!this.eligibleVariantIds.length || !this.welcomeKitVariantIds.length) {
      console.warn('Welcome kit eligibility or welcome kit variants not properly set.');
      return;
    }
    document.addEventListener('liquid-ajax-cart:request-end', this.handleCartUpdate);
    this.updateWelcomeKit();
  }

  disconnectedCallback() {
    document.removeEventListener('liquid-ajax-cart:request-end', this.handleCartUpdate);
  }

  handleCartUpdate = event => {
    if (!event?.detail?.requestState?.responseData?.ok) return;
    this.updateWelcomeKit();
  };

  async updateWelcomeKit() {
    if (this.isUpdatingWelcomeKit) return;
    this.isUpdatingWelcomeKit = true;
    lockCart();

    try {
      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error('Failed to fetch cart');
      const cart = await res.json();

      const hasEligibleItem = cart.items.some(item => this.eligibleVariantIds.includes(item.variant_id));
      const welcomeKitItems = cart.items.filter(item => item.properties?._is_it_welcome_kit === 'true');

      if (!hasEligibleItem) {
        if (welcomeKitItems.length) this.removeWelcomeKit(welcomeKitItems);
        return;
      }

      const hasSubscription = cart.items.some(item => this.eligibleVariantIds.includes(item.variant_id) && item.selling_plan_allocation);
      if (!hasSubscription) {
        if (welcomeKitItems.length) this.removeWelcomeKit(welcomeKitItems);
        return;
      }

      const existingVariantIds = welcomeKitItems.map(item => item.variant_id);
      const missingVariantIds = this.welcomeKitVariantIds.filter(id => !existingVariantIds.includes(id));
      if (missingVariantIds.length) this.addWelcomeKit(missingVariantIds);

      welcomeKitItems.forEach(item => {
        if (item.quantity !== 1) this.updateQuantity(item.key, 1);
      });
    } catch (error) {
      console.error('Error updating welcome kit:', error);
    } finally {
      this.isUpdatingWelcomeKit = false;
      unlockCart();
    }
  }

  addWelcomeKit(variantIds) {
    if (!window.liquidAjaxCart || !variantIds.length) return;
    window.liquidAjaxCart.add({ items: variantIds.map(id => ({ id, quantity: 1, properties: { _is_it_welcome_kit: 'true' } })) });
  }

  removeWelcomeKit(items) {
    if (!window.liquidAjaxCart || !items.length) return;
    const updates = {};
    items.forEach(item => item?.key && (updates[item.key] = 0));
    if (Object.keys(updates).length) window.liquidAjaxCart.update({ updates });
  }

  updateQuantity(key, quantity) {
    if (!window.liquidAjaxCart || !key) return;
    window.liquidAjaxCart.change({ id: key, quantity });
  }
}

customElements.define('welcome-kit-cart', WelcomeKitCart);

document.addEventListener('liquid-ajax-cart:request-start', lockCart);
document.addEventListener('liquid-ajax-cart:request-end', unlockCart);
